<template>
  <div class="newBlock item flex items-center" :class="{
    isMobile: isMobile()
  }">
    <div class="left-date" v-if="dataInfo.create_time">
      <div class="data1">{{ dayjs(dataInfo.create_time).format('YYYY.MM') }}</div>
      <div class="data2">{{ dayjs(dataInfo.create_time).format('DD') }}</div>
      <!-- <div class="data3">{{ dayjs(dataInfo.create_time).format('HH:mm:ss') }}</div> -->
    </div>

    <div class="right-content flex items-center justify-between">
      <div class="left-img rounded-lg overflow-hidden">
        <img v-if="dataInfo.cover" class="img-common" :src="dataInfo.cover.url" alt="">
      </div>

      <div class="right-content">
        <div @click="goDetail(dataInfo)" class="z-title ellipsis" :title="dataInfo.title">{{ dataInfo.title }}</div>

        <div v-if="dataInfo.from" class="link" @click="handleJump(dataInfo.from_url)">
          <i class="custom-icon">
            <img src="~@/assets/from.png" alt="/">
          </i>
          {{ dataInfo.from }}
        </div>

        <div class="desc line-clamp-5">{{ dataInfo.summary }}</div>

        <div class="btn">
          <el-button @click="goDetail(dataInfo)" type="primary" size="small">立即查看</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import dayjs from 'dayjs'
import { isMobile } from '@/utils/index'

export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {

    }
  },
  methods: {
    dayjs,
    isMobile,
    handleJump(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    goDetail(item) {
      const query = {
        moduleId: item.pid,
        moduleSecId: item.cate_id,
        contentId: item.object_code
      }

      window.open(`${window.location.origin}#/layout/contentDetail?${qs.stringify(query)}`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .newBlock.item {
    /*margin-bottom: 36px;*/
    padding: 28px 0;
    border-bottom: 1px solid #dfdfdf;

    &.isMobile {
      .left-date {
        display: none;
      }

      .right-content {
        display: block;
        width: 100%;

        .left-img {
          width: 100%;
          margin-bottom: 20px;
          margin-right: 0;
          // margin: 0 auto 20px;
        }

        .right-content {
          height: inherit;

          .z-title {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
          }

          .link {
            margin-bottom: 15px;
          }

          .desc {
            margin-bottom: 0;
          }

          .btn {
            margin-top: 20px;
            position: relative;
            // left: 50%;
            // transform: translateX(-50%);
            // left: ;
            left: inherit;
            bottom: inherit;
            text-align: center;
            // .el-button {
            //   margin: 0 auto;
            // }
          }
        }

        
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    .left-date {
      text-align: center;
      margin-right: 38px;
      .data1 {
        width: 58px;
        line-height: 22px;

        background-color: #0A1121;
        color: #fff;
        margin-bottom: 9px;
      }

      .data2 {
        font-size: 48px;
        line-height: 48px;
        font-weight: 400;
        color: #0A1121;
        margin-bottom: 9px;
      }

      .data3 {
        font-size: 12px;
        font-weight: 400;
        color: #878A95;
      }
    }

    .right-content {
      flex-grow: 1;

      .left-img {
        width: 442px;
        height: 248px;
        margin-right: 33px;
        // cursor: pointer;

        flex-shrink: 0;
      }

      .right-content {
        flex-grow: 1;
        height: 248px;
        position: relative;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*justify-content: space-between;*/
        .z-title {
          min-width: 200px;
          max-width: 450px;
          font-size: 18px;
          font-weight: normal;
          color: #0A1121;
          margin-bottom: 16px;
          cursor: pointer;
          &:hover {
            color: #1296DB;
          }
        }


        .link {
          font-size: 14px;
          color: #878A95;
          margin-bottom: 10px;
          cursor: pointer;

          .custom-icon {
            width: 16px;
            height: 16px;
            margin-right: 9px;
          }
        }

        .desc {
          font-size: 14px;
          font-weight: normal;
          color: #606266;
          line-height: 28px;
          // margin-bottom: 20px;
          // height: 200px;
          // background-color: red;
        }

        .btn {
          position: absolute;
          left: 0;
          bottom: 0;
          button {
            width: 100px;
          }
        }
      }
    }
  }

  .item:nth-last-of-type(1) {
    border: none
  }
</style>
